<template>

  <div class="hsEditor">
    <div class="hsImage">
        <img :src="imageUrl" />
        <!-- src="contents/img/_test.png" -->
    </div>

    <div class="hsData">
      {{elements}}
    </div>

    <div class="hsPoints">
            <div
              v-for="(item, index) in elements"
              :key="item.id"
              :class="['draggable',selectedIndex==index ? 'selected':'']"
              :style="{ top: item.top + 'px', left: item.left + 'px' }"
              @mousedown="startMove($event, index)">
              <span>{{ index + 1 }}</span>
            </div>
    </div>

    <!-- controls //////////////////////////////////////////////////////// -->
    <div class="hsControls">
      <div class="hsBtn" @click="addHotspot">
        <img src="editor/img/icon_add.svg" /> 
        <span>Add Hotspot</span>
      </div>
      <div class="hsBtn" @click="$refs.fileInput.click()">
        <img src="editor/img/icon_image.svg" /> 
        <span>Select Image</span>
        <input type="file" accept="image/*" ref="fileInput" style="display: none" @change="onFileSelected"/>
      </div>            
      <div class="hsBtn" @click="deleteSpot()">
        <img src="editor/img/icon_delete.svg" /> 
        <span>Delete</span>
      </div>
      <!-- {{elements}} -->
    </div>
    <!-- controls //////////////////////////////////////////////////////// -->


  </div>
</template>

<script>

    //todo
    //each time user adds a spot
      //add also a test title+desc and adjust the location automaticlly 
      //titles from left and right should have the same space
      //
      //
    //import { mapState, mapGetters, mapActions } from "vuex";
    //import Hotspots from "@/editor/hotspots.vue";
    export default 
    {
        components:{
          //hotspots:Hotspots
        },
        data()
        {
            return {
              elements: [], // stores all draggable items
              dragIndex: null,
              selectedIndex:null,
              imageUrl: null
            }
        },
        mounted()
        {

        },
        beforeDestroy() {
          // Clean up the object URL when the component is destroyed
          if (this.imageUrl) {
            URL.revokeObjectURL(this.imageUrl)
          }
        },
        methods:
        {
            deleteSpot()
            {
              this.elements.splice(this.selectedIndex,1);
            },
            onFileSelected(event) {
              const file = event.target.files[0]
              if (file) {
                // Free old object URL if one exists
                if (this.imageUrl) {
                  URL.revokeObjectURL(this.imageUrl)
                }
                // Create a temporary local URL for the image
                this.imageUrl = URL.createObjectURL(file)
              }
            },

            addHotspot()
            {
                this.elements.push({                                    
                  id: Date.now(), // unique id
                  title:"Temp element title", //locatioj of the title should be placed automaticlly 
                  desc:"",
                  top: 150,
                  left: 150,
                  offsetX:0, //this is the relative precent of the offset according to the screen size
                  offsetY:0,
                })
            },

            startMove(e, index) {
              this.dragIndex = index;
              this.selectedIndex = index;
              const el = this.elements[index];
              this.offsetX = e.clientX - el.left;
              this.offsetY = e.clientY - el.top;
              window.addEventListener('mousemove', this.onMove);
              window.addEventListener('mouseup', this.stopMove);
            },
            onMove(e) {
              if (this.dragIndex !== null) {
                this.elements[this.dragIndex].left = e.clientX - this.offsetX
                this.elements[this.dragIndex].top = e.clientY - this.offsetY
                this.updateElementOffsetData(this.dragIndex);
              }
            },
            stopMove() {
              this.updateElementOffsetData(this.dragIndex);
              this.dragIndex = null
              window.removeEventListener('mousemove', this.onMove)
              window.removeEventListener('mouseup', this.stopMove)
            },
            updateElementOffsetData(index)
            {
              //all point properties are according to the screen height 
              //beacuse the object image size is also affected by the sceen height 

              var offX = this.elements[index].left/window.innerHeight;
              var offY = this.elements[index].top/window.innerHeight;

              offX = Math.round(offX * 1000) / 1000  // → 0.817
              offY = Math.round(offY * 1000) / 1000  // → 0.817

              this.elements[this.dragIndex].offsetX = offX;
              this.elements[this.dragIndex].offsetY = offY;
            }

      }
    }

</script>


<style scoped>
  .hsData
  {
    position: fixed;top: 50vh;left: 50px;width: 20vw;height:auto;
    transform: translateY(-50%);
    border: solid 1px #ccc;
    font-size: 13px;
    padding: 20px;
    z-index: 1000;
    user-select: all;
    border-radius: 10px;
  }
  .hsEditor
  {
    width: 100%;
    height: 100%;
  }
  .hsImage
  {
    position: fixed;top: 0px;left: 0px;width: 100vw;height: 100vh;
    display: flex;
    align-content: center;
    align-items: center;
    z-index: 100;
  }
  .hsImage img{
    margin: auto;
    height: 50vh;
    width: auto;
  }

  .hsPoints
  {
    position: fixed;top: 0px;left: 0px;width: 100vw;height: 100vh;z-index: 150;
  }

  .hsControls
  {
    position: fixed;top: 0px;left: 0px;width: 100vw;height: 6px;z-index: 200;
    background: #000;
    display: flex;
    align-content: center;
    align-items: center;
    height: 100px;
    padding: 0px 50px;
    column-gap: 20px;
  }
  .hsBtn
  {
    column-gap: 3px;
    display: flex;
    align-items: center;
    align-content: center;
    background: transparent;
    border-radius: 5px;
    color: #ccc;border:solid 1px #ccc;
    cursor: pointer;font-size: 11px;
    height: 40px;
    padding: 0px 15px 0px 10px;
  }
  .hsBtn:hover{background: #0fb1f5;color: #fff;border:solid 1px #0fb1f5;}
  .hsBtn img
  {
    height: 30px;width:auto;
  }

.draggable {
  transform: translate(-50%,-50%);
  position: absolute;
  background:rgba(255,255,255,0.3);
  border: 2px solid #fff;
  width: 30px;height: 30px;
  cursor: move;
  user-select: none;
  border-radius: 20px;
  display: flex;
  align-items: center;
}
.draggable.selected
{
  border: 2px solid #0fb1f5;
}
.draggable span{
  font-size: 10px;margin: auto;
}

</style>



